import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";

const DialogResponsibleNotAttended = ({
	dialogCannotSaveInformation, space
}) => {
	return (
		<DialogAlertAction
			variant="secondary"
			width="700px"
			toggleShow={dialogCannotSaveInformation.toggle}
			show={dialogCannotSaveInformation.value}
			title={`No se puede guardar el cambio de estado
		de la reserva del espacio ${space.name}`}
			content="Recuerda que para cambiar el estado de la reserva de un espacio, debes registrar previamente la asistencia del alumno responsable.">
			<CustomButton
				text="Cerrar"
				width="120px"
				onClick={dialogCannotSaveInformation.hide} />
		</DialogAlertAction>
	);
}

export default DialogResponsibleNotAttended;